import { useTheme } from '@mui/material';

export default function EmbedWebRightIcon({
  isSelected,
  buttonBgColor = '#fff',
  buttonColor = '#000'
}: {
  isSelected?: boolean;
  buttonBgColor?: string;
  buttonColor?: string;
}) {
  const theme = useTheme();
  return (
    <svg width='252' height='180' viewBox='0 0 252 180' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='251.333' height='180' rx='8' fill='#ECECEC' />
      {isSelected && <rect x='0.5' y='0.5' width='250.333' height='179' rx='7.5' stroke={theme.palette.primary.main} />}
      <path
        d='M22.6662 25.5043C24.2337 25.5043 25.5043 24.2337 25.5043 22.6662C25.5043 21.0988 24.2337 19.8281 22.6662 19.8281C21.0988 19.8281 19.8281 21.0988 19.8281 22.6662C19.8281 24.2337 21.0988 25.5043 22.6662 25.5043Z'
        fill='#EF4444'
      />
      <path
        d='M31.6506 25.5043C33.218 25.5043 34.4887 24.2337 34.4887 22.6662C34.4887 21.0988 33.218 19.8281 31.6506 19.8281C30.0832 19.8281 28.8125 21.0988 28.8125 22.6662C28.8125 24.2337 30.0832 25.5043 31.6506 25.5043Z'
        fill='#FCD34D'
      />
      <path
        d='M40.6272 25.5043C42.1946 25.5043 43.4653 24.2337 43.4653 22.6662C43.4653 21.0988 42.1946 19.8281 40.6272 19.8281C39.0597 19.8281 37.7891 21.0988 37.7891 22.6662C37.7891 24.2337 39.0597 25.5043 40.6272 25.5043Z'
        fill='#83E83F'
      />
      <path
        d='M223.041 45.3281H28.2953C23.619 45.3281 19.8281 48.7541 19.8281 52.9803V81.6759C19.8281 85.9021 23.619 89.3281 28.2953 89.3281H223.041C227.717 89.3281 231.508 85.9021 231.508 81.6759V52.9803C231.508 48.7541 227.717 45.3281 223.041 45.3281Z'
        fill={theme.palette.primary.main}
      />
      <path
        d='M88.8887 95.9375H24.5583C21.9459 95.9375 19.8281 98.0553 19.8281 100.668V100.668C19.8281 103.28 21.9459 105.398 24.5583 105.398H88.8887C91.5011 105.398 93.6188 103.28 93.6188 100.668C93.6188 98.0553 91.5011 95.9375 88.8887 95.9375Z'
        fill={theme.palette.primary.main}
      />
      <rect x='195.156' y='125.227' width='36.3492' height='36.3492' rx='18.1746' fill={buttonBgColor} />
      <path
        d='M213.332 145.066C212.562 145.066 211.911 144.799 211.378 144.266C210.844 143.733 210.578 143.081 210.578 142.312V135.703C210.578 134.933 210.844 134.282 211.378 133.749C211.911 133.216 212.562 132.949 213.332 132.949C214.101 132.949 214.752 133.216 215.286 133.749C215.819 134.282 216.085 134.933 216.085 135.703V142.312C216.085 143.081 215.819 143.733 215.286 144.266C214.752 144.799 214.101 145.066 213.332 145.066ZM212.505 153.051V149.421C210.688 149.213 209.178 148.434 207.976 147.082C206.773 145.731 206.172 144.141 206.172 142.312H207.824C207.824 143.836 208.361 145.134 209.435 146.208C210.509 147.282 211.808 147.819 213.332 147.819C214.855 147.819 216.154 147.282 217.228 146.208C218.302 145.134 218.839 143.836 218.839 142.312H220.491C220.491 144.141 219.89 145.731 218.688 147.082C217.485 148.434 215.975 149.213 214.158 149.421V153.051H212.505Z'
        fill={buttonColor}
      />
    </svg>
  );
}
